import React from "react";

import { FormattedMessage } from "react-intl";

import { Text } from "@/components/atoms/Text";

interface DayRateDiscountProps {
  price: number;
  currency: string;
  discount: {
    value: number;
    apply_as: string;
    obj_state: string;
  };
}

export const DayRateDiscount: React.FC<DayRateDiscountProps> = ({
  discount,
}) => {
  return (
    <div className="tw-flex tw-justify-between tw-border-t tw-border-gray-200 tw-py-16 tw-px-24">
      <div className="tw-flex tw-items-center tw-gap-4">
        <Text data-testing-id="discount8PlusHoursLabel">
          <FormattedMessage defaultMessage="8+ hour discount" />
        </Text>
      </div>
      <Text
        typeface="body-1-long"
        className="tw-px-12 tw-py-2 tw-bg-gray-100 tw-rounded-12"
      >
        <FormattedMessage
          defaultMessage="{discount}% off"
          values={{ discount: discount.value }}
        />
      </Text>
    </div>
  );
};
